var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.00003 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #0080b6;\n      }\n\n      .cls-3 {\n        fill: #0080b4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.00015,
    cy: 64.00024,
    r: 61.88574
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.00003,4.22836c32.95819,0,59.77161,26.81345,59.77161,59.77164s-26.81342,59.77161-59.77161,59.77161S4.22836,96.95819,4.22836,64,31.04181,4.22836,64.00003,4.22836m0-4.22836C28.65378,0,0,28.65378,0,64s28.65378,64,64.00003,64,64-28.65375,64-64S99.34622,0,64.00003,0h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.9805 52.86624 41.50298 76.78434 46.83888 76.78434 59.31592 52.86624 53.9805 52.86624"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.91967 33.81366 71.73968 48.79996 76.74939 48.79996 63.91967 24.20812 51.09133 48.79996 56.10336 48.79996 63.91967 33.81366"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.60582 53.02412 81.08191 76.94222 86.33774 76.78434 73.8607 52.86624 68.60582 53.02412"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.68562 80.90218 82.02949 89.22952 45.81009 89.22952 50.15629 80.90218 44.69206 80.90218 38.12584 93.48731 38.12584 93.79189 89.87417 93.79189 83.14846 80.90218 77.68562 80.90218"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.5224875a73676d93cc859797009474d1.svg";
export { ForwardRef as ReactComponent };